export const totalItemsInShipmentWithoutItem = (shipment, item) =>
  shipment.items.reduce((total, i) => {
    if (i.productVariantId === item.productVariantId) {
      return total;
    }
    return total + i.quantity;
  }, 0);

export const totalPriceInSubscriptionShipmentWithoutItem = (
  clubSubscriptionShipment,
  item
) =>
  clubSubscriptionShipment.items.reduce((total, i) => {
    if (i.productVariantId === item.productVariantId) {
      return total;
    }
    return total + i.quantity * i.price;
  }, 0);

export const totalPriceInTraditionalShipmentWithoutItem = (
  clubPackage,
  clubMemberShipment,
  item
) =>
  clubMemberShipment.items.reduce((total, i) => {
    if (i.productVariantId === item.productVariantId) {
      return total;
    }
    const packageProduct = clubPackage.items.find(
      (cPitem) => cPitem.productVariantId === i.productVariantId
    );
    if (packageProduct) {
      return total + i.quantity * packageProduct.price;
    }
    return total;
  }, 0);
